import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { goals } from '../data/content';
export function GoalSection() {
  return <section aria-labelledby="meta" className="bg-cream" data-id="element-85" data-mp="3sblyuhel8zat">
      <div className="mx-auto max-w-page px-3 py-6 text-center sm:px-6 sm:py-8" data-id="element-86" data-mp="3sd5cs1cruy9f">
        <Reveal data-id="element-87" data-mp="3nd14uzpxjbut">
          <h2 id="meta" className="mx-auto max-w-3xl font-display text-lg font-black uppercase leading-[1.08] text-ink sm:text-2xl lg:text-3xl" data-id="element-88" data-mp="3nelse5dttuj6">
            🎯 Una meta concreta: pasar de “no sé por dónde empezar” a
            comprender las bases del coreano
          </h2>
          <p className="mt-1.5 text-[0.75rem] font-extrabold uppercase tracking-[0.18em] text-coral sm:text-[0.82rem]" data-id="element-89" data-mp="34lroq7lnlou9">
            Al completar el sistema tendrás una base para:
          </p>
        </Reveal>

        <ul className="mx-auto mt-3 grid max-w-4xl gap-1.5 text-left sm:grid-cols-2" data-id="element-90" data-mp="jw27jnxh9qye">
          {goals.map((goal, i) => <Reveal key={goal} as="li" delay={i * 0.03} className="flex items-start gap-2 rounded-lg border border-sky/70 bg-white px-2.5 py-2 font-body text-[0.78rem] font-semibold leading-snug text-ink sm:text-[0.82rem]" data-id="element-91" data-mp="2h0ln61gveyg2" data-mpi={i}>
              <CheckIcon size={15} className="mt-0.5 flex-shrink-0 text-coral" strokeWidth={3} data-id="element-92" data-mp="2v0d5ufic130e" />
              {goal}
            </Reveal>)}
        </ul>

        <Reveal delay={0.08} className="mx-auto mt-4 max-w-2xl" data-id="element-93" data-mp="22da7pohkiuao">
          <p className="font-body text-[0.8rem] leading-snug text-slate sm:text-sm" data-id="element-94" data-mp="27bliq2jlnauh">
            No se trata de memorizar cientos de páginas.{' '}
            <span className="font-bold text-ink" data-id="element-95" data-mp="2c4n1ilmxfujc">
              Se trata de comprender lo que estás viendo, reconocer patrones y
              utilizar lo aprendido paso a paso.
            </span>
          </p>
        </Reveal>

        <Reveal delay={0.1} className="mt-4 flex justify-center" data-id="element-96" data-mp="2mwwz3qg2pjo1">
          <CtaButton size="lg" data-id="element-97" data-mp="2mvc11qujvilf">
            ¡SÍ! QUIERO APRENDER COREANO DESDE CERO
          </CtaButton>
        </Reveal>
      </div>
    </section>;
}